// extracted by mini-css-extract-plugin
module.exports = {"image":"Error_image__3w0G5"};